"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboUrgent = isComboUrgent;
const constants_1 = require("@daytrip/constants");
const date_fns_1 = require("date-fns");
function isComboUrgent(comboDepartureAtUtc) {
    return new Date(comboDepartureAtUtc) < (0, date_fns_1.addDays)(new Date(), constants_1.POST_BOTH_COMBO_AND_SINGLE_OFFERS_TRESHOLD_DAYS);
}
//# sourceMappingURL=isComboUrgent.js.map